export default '/build/62ff2564.svg'